export const ButtonColorGradient = 'linear-gradient(180deg, #EEAB10 0%, #FFC133 100%)';
export const ButtonColor = '#EEAB10';
export const PrimaryColor = '#3A3E3F';

export const flexStyles = { 
    flexRowStart: { 
        display: 'flex', 
        flexDirection: 'row', 
        justifyContent: 'flex-start', 
    }, 
    flexRowEnd: { 
        display: 'flex', 
        flexDirection: 'row', 
        justifyContent: 'flex-end', 
    },
    flexRowSpaceBetween: { 
        display: 'flex', 
        flexDirection: 'row', 
        justifyContent: 'space-between', 
    },
    flexColumnStart: { 
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'flex-start', 
    }, 
    flexColumnEnd: { 
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'flex-end', 
    },
    flexColumnSpaceBetween: { 
        display: 'flex', 
        flexDirection: 'column', 
        justifyContent: 'space-between', 
    },
};
